<template>
  <v-tabs-page :tabs="tabs" />
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { people, trophy, personCircle, calendar, shieldCheckmark } from "ionicons/icons";
import VTabsPage from "@/common/components/VTabsPage.vue";
import { useUserStore } from "@/common/store/user.store";

export default defineComponent({
  components: {
    VTabsPage,
  },

  setup() {
    const { t } = useI18n();
    const { currentUser } = storeToRefs(useUserStore());

    const tabs = computed(() => {
      const items = [
        {
          id: "matches",
          label: t("message.userDashboard.tabs.matches"),
          icon: calendar,
          href: "/matches",
        },
        {
          id: "groups",
          label: t("message.userDashboard.tabs.groups"),
          icon: people,
          href: "/groups",
        },
        {
          id: "competitions",
          label: t("message.userDashboard.tabs.competitions"),
          icon: trophy,
          href: "/competitions",
        },
        {
          id: "account",
          label: t("message.userDashboard.tabs.account"),
          icon: personCircle,
          href: "/account",
        },
      ];

      if (currentUser.value?.role === "admin") {
        items.push({
          id: "admin",
          label: t("message.userDashboard.tabs.admin"),
          icon: shieldCheckmark,
          href: "/admin",
        });
      }

      return items;
    });

    return { tabs };
  },
});
</script>
